export default [
  {
    path: '/admin/uom-categories',
    name: 'uom-category',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/uom-category')
  }
]
